module.exports = __webpack_public_path__ + "img/photo-04.2721d74f.webp";